var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusError = function SvgStatusError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.5 4.87c.27-.48.72-.48 1 0l7.66 13.26c.28.48.05.87-.5.87H4.36c-.58 0-.8-.4-.53-.87L11.5 4.87zM11 9h2v5h-2V9zm0 6h2v2h-2v-2z"
  })));
};
export default SvgStatusError;